import axios from "axios"
import moment from "moment"
import appSettings from "../../appconfig.json";

export default {
	state: {
		environments: {
			development: "development",
			staging: "staging",
			production: "production"
		},
		serverUrl: "",
		instance: {}
	},

	actions: {
		serverUrl(actionContext, companyCode) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })
					actionContext.commit("MopaneApi/setServerUrl", "", { root: true })
					actionContext.commit("Profile/setProfile", { companycode: companyCode }, { root: true })

					actionContext.dispatch("MopaneApi/createInstance", null, { root: true }).then(function () {
						if (process.env.NODE_ENV === actionContext.rootState.MopaneApi.environments.development
							|| process.env.NODE_ENV === actionContext.rootState.MopaneApi.environments.staging) {
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()

							return
						}

						actionContext.getters["getInstance"].get(`Service/ServerUrl?companyCode=${companyCode}`)
							.then(response => {
								actionContext.commit("MopaneApi/setServerUrl", `https://new${response.data}.brevity.com.au/v1`, { root: true })
								actionContext.dispatch("MopaneApi/createInstance", null, { root: true })
								actionContext.commit("Loading/hide", null, { root: true })

								resolve()
							})
							.catch(exception => {
								actionContext.dispatch("processErrorResponse", exception)
								actionContext.commit("Loading/hide", null, { root: true })

								reject(exception)
							})
					})
				}
				catch (exception) {
					actionContext.dispatch("processErrorResponse", exception)
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		createInstance: function (actionContext) {
			return new Promise((resolve, reject) => {
				try {
					var cancelToken = axios.CancelToken
					var source = cancelToken.source()

					if (actionContext.rootState.MopaneApi.serverUrl === "")
						actionContext.commit("MopaneApi/setServerUrl", localStorage.serverUrl, { root: true })
						
					var instance = axios.create({
						baseURL: actionContext.rootState.MopaneApi.serverUrl,
						timeout: appSettings.mopaneApi.timeout,
						headers: {
							"Content-Type": "application/json"
						},
						cancelToken: source.token
					})

					instance.interceptors.request.use(function (config) {
						var currentTimeClockShift = actionContext.rootGetters["Shifts/currentTimeClockShift"]
						
						var isLoginValid = actionContext.rootState.Profile.loginTime == null
							|| moment(actionContext.rootState.Profile.loginTime)
								.add(actionContext.rootState.Profile.profile.logintimeout || 8, "hours")
								.isSameOrAfter(moment())
							|| (currentTimeClockShift != null
								&& moment(currentTimeClockShift.servicedate, "DD/MM/YYYY h:mm:ss A")
									.add(8, "hours")
									.isSameOrAfter(moment()))
						
						if (!isLoginValid) {
							actionContext.commit("Toasts/showError", { title: "Session Expired", content: "Your session has expired!" }, { root: true })
							actionContext.dispatch("Profile/logout", "", { root: true })
						}

						actionContext.commit("Profile/extendLoginTime", null, { root: true });

						return config
					})

					actionContext.commit("setInstance", instance)

					resolve()
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception)

					reject(exception)
				}
			})
		},
		processErrorResponse: function (actionContext, response) {
			return new Promise((resolve, reject) => {
				try {
					if (response.response) {
						if (response.response.status == 401) {
							actionContext.dispatch("Profile/logout", null, { root: true })
						}
						else {
							actionContext.commit("Toasts/showError", { title: "Error", content: "An unexpected error occured" }, { root: true })

							if (process.env.DEBUGGING)
								console.error(response.response.data)

							actionContext.dispatch("logError", response.response.data)
						}
					}
					else if (typeof (response) === "string") {
						actionContext.commit("Toasts/showError", { title: "Error", content: "An unexpected error occured" }, { root: true })

						if (process.env.DEBUGGING)
							console.error(response.message)

						actionContext.dispatch("logError", response.message)
					}
					else {
						actionContext.commit("Toasts/showError", { title: "Error", content: "An unexpected error ocurred" }, { root: true })

						if (process.env.DEBUGGING)
							console.error(response.message)

						actionContext.dispatch("logError", response.message)
					}

					resolve()
				}
				catch (exception) {
					actionContext.commit("Toasts/showError", { title: "Error", content: "An unexpected error ocurred" }, { root: true })

					if (process.env.DEBUGGING)
						console.error(response.message)

					actionContext.dispatch("logError", response.message)

					reject(exception)
				}
			})
		},
		logError: function (actionContext, error) {
			var username = ""
			var companyCode = ""

			if (actionContext.rootState.Profile.profile) {
				if (actionContext.rootState.Profile.profile.fullname != undefined)
					username = actionContext.rootState.Profile.profile.fullname;

				if (actionContext.rootState.Profile.profile.companycode != undefined)
					companyCode = actionContext.rootState.Profile.profile.companycode;
			}

			return new Promise((resolve, reject) => {
				actionContext.getters["getInstance"].get(`Service/LogError?username=${username}&companyCode=${companyCode}&appversion=Mopane%20Web%20Portal&error=${error + ". " + window.location.href}&linenumber=0`)
					.then(response => {
						resolve()
					})
					.catch(response => {
						reject(response)
					})
			})
		}
	},

	mutations: {
		setServerUrl(state, serverUrl) {
			if (serverUrl == null || serverUrl == "") {
				if (process.env.NODE_ENV === state.environments.development) {
					state.serverUrl = appSettings.mopaneApi.devUrl
				}
				else if (process.env.NODE_ENV === state.environments.staging) {
					state.serverUrl = appSettings.mopaneApi.stagingUrl
				}
				else if (process.env.NODE_ENV === state.environments.production) {
					state.serverUrl = appSettings.mopaneApi.prodUrl
				}
				else {
					state.serverUrl = appSettings.mopaneApi.prodUrl
				}
			}
			else {
				state.serverUrl = serverUrl
			}

			localStorage.serverUrl = state.serverUrl
		},
		setInstance: function (state, instance) {
			state.instance = instance
		}
	},

	getters: {
		getInstance: function (state, getters, rootState) {
			if (rootState.Profile.profile) {
				if (rootState.Profile.profile.companycode != undefined)
					state.instance.defaults.headers.common["Company-Code"] = rootState.Profile.profile.companycode;

				if (rootState.Profile.profile.authcode != undefined)
					state.instance.defaults.headers.common["Auth-Code"] = rootState.Profile.profile.authcode;

				if (rootState.Profile.profile.userid != undefined)
					state.instance.defaults.headers.common["User-Id"] = rootState.Profile.profile.userid;
			}

			return state.instance
		},
		getObjectArrayFromTables: function (state, getters) {
			return (tables) => {
				var obj = {};

				for (var i = 0; i < tables.length; i++) {
					var table = tables[i];
					var propertyName = table.tablename ? table.tablename : i;

					obj[propertyName] = getters["getObjectArrayFromTable"](table);
				}

				return obj;
			}
		},
		getObjectArrayFromTable: function () {
			return (table) => {
				var list = [];

				if (!table.records)
					return [];

				for (var i = 0; i < table.records.length; i++) {
					var record = table.records[i];
					var obj = {};

					for (var j = 0; j < table.columnnames.length; j++) {
						var columnName = table.columnnames[j];

						obj[columnName] = record[j];
					}

					list.push(obj);
				}

				return list;
			}
		}
	},

	namespaced: true
}